<template>
  <div class="wrap">
    <el-image-viewer 
      v-if="imgViewerVisible" 
      :on-close="closeImgViewer" 
      :url-list="imgList" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgViewerVisible: false
    }
  },
  components:{ 
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  props: {
    imgList: {
      type: Array,
      default: () => [] // ✅ 修正：使用工厂函数返回默认数组
    }
  },


  methods: {
    showImgViewer(){
      this.imgViewerVisible = true;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'hidden';
      document.addEventListener("touchmove", m, false); // 禁止页面滑动

    },
    closeImgViewer(){
      this.imgViewerVisible = false;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener("touchmove", m, true);
    },
  }
};
</script>

<style lang="less" scoped>
.image-content{
  width: 100%;
  height: 1500px;
  background: pink;
}
// html:has(.el-image-viewer__wrapper) {
//   overflow: hidden;
// }
</style>